import { useEffect, useState } from "react";
import Logo from "assets/images/Logo_lg_colo.svg";

const STORAGE_KEY = "adroit-initial-load-complete";
const MIN_DISPLAY_MS = 2200;
const EXIT_MS = 700;

const PARTICLES = [
    { top: "18%", left: "16%" },
    { top: "22%", right: "14%" },
    { top: "68%", left: "12%" },
    { top: "72%", right: "18%" },
    { top: "42%", left: "8%" },
    { top: "48%", right: "10%" },
];

const InitialLoader = () => {
    const [visible, setVisible] = useState(false);
    const [exiting, setExiting] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem(STORAGE_KEY)) {
            return;
        }

        let cancelled = false;
        let exitTimer;

        setVisible(true);
        document.body.classList.add("loader-active");

        const minDelay = new Promise((resolve) =>
            setTimeout(resolve, MIN_DISPLAY_MS)
        );

        const pageReady = new Promise((resolve) => {
            if (document.readyState === "complete") {
                resolve();
                return;
            }
            window.addEventListener("load", resolve, { once: true });
        });

        Promise.all([minDelay, pageReady]).then(() => {
            if (cancelled) {
                return;
            }

            setExiting(true);
            exitTimer = setTimeout(() => {
                if (cancelled) {
                    return;
                }

                sessionStorage.setItem(STORAGE_KEY, "true");
                setVisible(false);
                document.body.classList.remove("loader-active");
            }, EXIT_MS);
        });

        return () => {
            cancelled = true;
            clearTimeout(exitTimer);
            document.body.classList.remove("loader-active");
        };
    }, []);

    if (!visible) {
        return null;
    }

    return (
        <div
            className={`initial-loader ${exiting ? "initial-loader--exit" : ""}`}
            role="status"
            aria-live="polite"
            aria-label="Loading website"
        >
            <div className="initial-loader__mesh" aria-hidden="true" />
            <div className="initial-loader__grid" aria-hidden="true" />

            <div className="initial-loader__ring initial-loader__ring--outer" />
            <div className="initial-loader__ring initial-loader__ring--inner" />

            <div className="initial-loader__content">
                <div className="initial-loader__logo-wrap">
                    <img
                        src={Logo}
                        alt="Adroit Systems"
                        className="initial-loader__logo"
                    />
                </div>

                <p className="initial-loader__tagline">
                    Let&apos;s get <span>IT</span> done.
                </p>

                <div className="initial-loader__progress" aria-hidden="true">
                    <div className="initial-loader__progress-track">
                        <div className="initial-loader__progress-bar" />
                    </div>
                    <span className="initial-loader__progress-label">
                        Preparing your experience
                    </span>
                </div>
            </div>

            <div className="initial-loader__particles" aria-hidden="true">
                {PARTICLES.map((position, i) => (
                    <span
                        key={i}
                        className="initial-loader__particle"
                        style={{ ...position, animationDelay: `${i * 0.25}s` }}
                    />
                ))}
            </div>
        </div>
    );
};

export default InitialLoader;
